export function getRelativePath() {
  return process.env.REACT_APP_RELATIVE_PATH;
}
